import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import OptionsButtonComponent from 'webapp/components/options-button';

import type { AnyBatchSelect } from 'webapp/models-custom/batch-select';

interface Args {
	model: AnyBatchSelect;
}

export default class CommonBatchButtonComponent extends Component<Args> {
	get allCount() {
		return this.args.model.allItems.length;
	}

	get selectedCount() {
		return this.args.model.selectedItems.length;
	}

	get options() {
		return this.args.model.options;
	}

	get theme(): string {
		const firstOption = this.options[0];
		return firstOption?.theme || 'blue';
	}

	get showSelectButton() {
		return this.selectedCount < this.allCount;
	}

	get showDeselectButton() {
		return this.selectedCount > 0;
	}

	@action
	selectAll() {
		this.args.model.selectAll();
	}

	@action
	unselectAll() {
		this.args.model.unselectAll();
	}

	@action
	doAction(actionName: string) {
		this.args.model.triggerBatchAction(actionName);
	}

	@action
	setupView() {
		document.body.classList.add('has-batch-button');
	}

	@action
	teardownView() {
		document.body.classList.remove('has-batch-button');
	}
	<template>
		<div class="batch-button" {{didInsert this.setupView}} {{willDestroy this.teardownView}}>
			{{#if this.showDeselectButton}}
				<a role="button" class="select-all" {{on "click" this.unselectAll}}>Deselect all</a>
			{{/if}}
			{{#if this.showSelectButton}}
				<a role="button" class="select-all" {{on "click" this.selectAll}}>Select all ({{this.allCount}})</a>
			{{/if}}
			<OptionsButtonComponent
				@options={{this.options}}
				@onAction={{this.doAction}}
				@theme={{this.theme}}
				@extraClass="batch-actions-btn"
			/>
		</div>
	</template>
}
